import diag_14_1 from "../../../../src/verilog/images/subroutines.svg";
import * as React from 'react';
export default {
  diag_14_1,
  React
};